/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const emptyStateTokens = {
  CoreTextColor: '#656b6b',
  CorePaddingDefault: '110px',
} as const;
